import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        couponTotal: 0,
        couponInfo: [],
    },
    mutations: {
        setCouponTotal(state, payload) {
            state.couponTotal = payload;
        },
        setCouponInfo(state, payload) {
            state.couponInfo = payload;
        },
    },
    actions: {
        findCouponInfo({ commit }, data) {
            api.queryCouponInfo(data).then(response => {
                commit('setCouponTotal', response.data.totalCount);
                let list = response.data.list;
                list.forEach(item => {
                    const regexp = /(?:\.0*|(\.\d+?)0+)$/
                    item.rate = (((item.rate * 10000) / 100).toFixed(5)).replace(regexp, '$1');
                });
                commit('setCouponInfo', list);
            })
        },
    }
}

appStore.registerModule('coupon', store);